import React from 'react';
import { Card, CardBody, Button } from '@heroui/react';

const ConfigErrorScreen = ({ missingVars = [] }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-red-50 dark:from-gray-900 dark:to-gray-800 p-4">
      <Card className="max-w-3xl w-full">
        <CardBody className="p-8">
          <div className="text-center mb-6">
            <svg
              className="w-24 h-24 mx-auto text-orange-500 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>

            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
              Configuration Required
            </h1>

            <p className="text-lg text-gray-600 dark:text-gray-400 mb-2">
              The application is missing required environment variables.
            </p>

            <p className="text-sm text-gray-500 dark:text-gray-500">
              This usually happens when deploying to a new environment.
            </p>
          </div>

          {missingVars.length > 0 && (
            <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 mb-6">
              <h2 className="text-sm font-semibold text-orange-900 dark:text-orange-300 mb-3">
                Missing Environment Variables:
              </h2>
              <ul className="space-y-1">
                {missingVars.map((varName) => (
                  <li
                    key={varName}
                    className="text-sm font-mono text-orange-800 dark:text-orange-400 flex items-center"
                  >
                    <span className="mr-2">•</span>
                    {varName}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
            <h2 className="text-sm font-semibold text-blue-900 dark:text-blue-300 mb-2 flex items-center">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              For Deployment Administrators:
            </h2>
            <ol className="text-sm text-blue-800 dark:text-blue-300 space-y-2 list-decimal list-inside">
              <li>Access your deployment platform (Cloudflare Pages, Vercel, etc.)</li>
              <li>Navigate to Environment Variables settings</li>
              <li>Add the missing Firebase configuration variables</li>
              <li>Redeploy the application</li>
            </ol>
            <p className="text-xs text-blue-600 dark:text-blue-400 mt-3">
              See <code className="bg-blue-100 dark:bg-blue-900 px-1 py-0.5 rounded">PRODUCTION_ENV_SETUP.md</code> for complete setup instructions.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              color="primary"
              size="lg"
              onPress={() => window.location.reload()}
            >
              Retry Connection
            </Button>

          </div>

          <p className="text-center text-xs text-gray-500 dark:text-gray-600 mt-8">
            If you're a user seeing this, please contact the site administrator.
          </p>
        </CardBody>
      </Card>
    </div>
  );
};

export default ConfigErrorScreen;
